import React from 'react';
import './Pages.css';

export default function AboutPage() {
  return (
    <div className="static-page fade-in">
      <div className="static-card card">
        <h1>About Crunchy</h1>

        <section className="static-section">
          <h2>Our Platform</h2>
          <p>
            Crunchy is a vibrant social community built around the love of cooking and sharing recipes. Whether you're a seasoned chef or just starting out in the kitchen, Crunchy brings people together through the universal language of food. Our platform lets you discover new dishes from creators around the world, save your favourites to personal collections, follow the cooks who inspire you, and share your own culinary creations with a community that genuinely appreciates good food. From quick weeknight dinners to elaborate weekend bakes, Crunchy is your go-to destination for recipes that are tried, tested, and loved by real home cooks.
          </p>
          <p>
            We believe that the best recipes come from real people — not faceless corporations. That's why every recipe on Crunchy is shared by a member of our community, complete with personal notes, tips, and honest feedback from fellow food lovers. Our category-based discovery system, dietary preference filters, and personalised recommendations make it easy to find exactly what you're looking for, whether that's a gluten-free birthday cake, a quick vegan lunch, or the perfect slow-cooked stew for a cold evening.
          </p>
        </section>

        <section className="static-section">
          <h2>The Creator</h2>
          <p>
            Crunchy was created by <strong>Aviv Cohen</strong>, a web entrepreneur and enthusiastic cook who wanted to build a space where food lovers could connect, inspire one another, and share their favourite recipes without the noise and clutter of traditional social media. With a background in web development and a deep passion for technology-driven communities, Aviv set out to create a platform that puts the recipe — and the people behind it — front and centre.
          </p>
          <p>
            Have questions, feedback, or partnership enquiries? Aviv would love to hear from you. Reach out at{' '}
            <a href="mailto:aviv@crunchyrecipes.co.uk">aviv@crunchyrecipes.co.uk</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
